import { InputField } from 'lib/iterable-hook-form/FormField';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { OptionText } from '../../styles';

export const RecipientTimeZonesWrapper = styled.div`
  margin-top: ${spacing.threeQuarter};
  /** Radio size (24px) + RadioList gap (spacing.half) */
  margin-left: calc(24px + ${spacing.half});
`;

export const ProjectTimeZone = styled(OptionText)`
  color: ${colors.textSecondary};
`;

export const RecurrenceFrequencyInputField = styled(InputField)`
  width: ${pxToRem(110)};
  input {
    width: ${spacing.base};
  }
`;

export const RowWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
`;
